import { Modal, Col, Row } from 'antd'
import { PropsWithChildren, FC } from 'react'
import { ExclamationCircleOutlined } from '@ant-design/icons'

import Text from '~/core/Text'
import Button from '~/core/Button'
import getColor from '~/lib/getColor'

interface FailedInvitesModalPropsType {
    failedEmails: string[]
    onClose: () => void
}

export const FailedInvitesModal: FC<
    PropsWithChildren<FailedInvitesModalPropsType>
> = ({ failedEmails, onClose }) => {
    return (
        <Modal
            onCancel={onClose}
            visible={!!failedEmails.length}
            footer={[
                <Button key={'close button'} onClick={onClose}>
                    Close
                </Button>,
            ]}
            closable={false}
        >
            <Row justify="center">
                <Col span={2}>
                    <ExclamationCircleOutlined
                        height={'21px'}
                        width={'21px'}
                        style={{
                            color: getColor('error6'),
                            fontSize: '21px',
                        }}
                    />
                </Col>
                <Col span={22}>
                    <Text
                        fontWeight={400}
                        fontSize={'16px'}
                        lineHeight={'24px'}
                        element={'h2'}
                        style={{ marginTop: '0px' }}
                    >
                        The following invitations could not be sent
                    </Text>
                    <ul
                        style={{
                            listStyle: 'none',
                            marginBottom: '16px',
                            paddingLeft: '0',
                        }}
                    >
                        {failedEmails.map(email => {
                            return (
                                <li key={email}>
                                    <Text
                                        fontWeight={300}
                                        fontSize={'14px'}
                                        lineHeight={'26px'}
                                    >
                                        {email}
                                    </Text>
                                </li>
                            )
                        })}
                    </ul>
                    <Text
                        fontWeight={300}
                        fontSize={'14px'}
                        lineHeight={'22px'}
                        color={getColor('blackAlpha45')}
                    >
                        Note: People in a different Business Account cannot be
                        invited.
                    </Text>
                </Col>
            </Row>
        </Modal>
    )
}

export default FailedInvitesModal
